import style from './toolTipCompoStyle.module.css';

const ToolTip = (props) => {
  const {message} = props
  return (
    <div className={style.toolTip}>
      <span className={style.toolTipText}>{message}</span>
      <span>
        <img
          src={require('../../assets/images/iconInformation.png')}
          alt=""
          className={style.tip}
        />
      </span>
    </div>
  );
};
export default ToolTip;
